var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Toaster } from "@/components/ui/toaster";
import { useToast } from "@/components/ui/use-toast";
import { useEffect, useState } from 'react';
import { VideoFetcher } from './components/VideoFetcher';
import { VideoGrid } from './components/VideoGrid';
import { VideoPlayer } from './components/VideoPlayer';
import { fetchVideos } from './data';
export var App = function () {
    var _a = useState([]), videos = _a[0], setVideos = _a[1];
    var _b = useState(null), selectedVideo = _b[0], setSelectedVideo = _b[1];
    var _c = useState(true), loading = _c[0], setLoading = _c[1];
    var _d = useState(null), error = _d[0], setError = _d[1];
    var toast = useToast().toast;
    var loadVideos = function () { return __awaiter(void 0, void 0, void 0, function () {
        var fetchedVideos, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setLoading(true);
                    setError(null);
                    return [4 /*yield*/, fetchVideos()];
                case 1:
                    fetchedVideos = _a.sent();
                    setVideos(fetchedVideos);
                    return [3 /*break*/, 4];
                case 2:
                    err_1 = _a.sent();
                    setError(err_1 instanceof Error ? err_1.message : 'Failed to load videos');
                    toast({
                        variant: "destructive",
                        title: "Error",
                        description: "Failed to load videos. Please try again.",
                    });
                    return [3 /*break*/, 4];
                case 3:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        loadVideos();
    }, []);
    var handleVideoSelect = function (video) {
        setSelectedVideo(video);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    var handleFetchComplete = function () {
        loadVideos();
        toast({
            title: "Success",
            description: "Video fetched successfully!",
        });
    };
    return (_jsxs("div", { className: "min-h-screen bg-gray-50", children: [_jsx("nav", { className: "bg-white shadow-sm", children: _jsx("div", { className: "container mx-auto px-4 py-4", children: _jsx("h1", { className: "text-2xl font-bold text-gray-900", children: "Video Gallery" }) }) }), _jsxs("main", { className: "container mx-auto px-4 py-6", children: [_jsx("div", { className: "max-w-3xl mx-auto mb-8", children: _jsx(VideoFetcher, { onVideoFetched: handleFetchComplete }) }), error ? (_jsx("div", { className: "max-w-3xl mx-auto p-4 bg-red-50 border border-red-200 rounded-lg text-red-700", children: _jsxs("div", { className: "flex items-center", children: [_jsx("svg", { className: "w-5 h-5 mr-2", fill: "currentColor", viewBox: "0 0 20 20", children: _jsx("path", { fillRule: "evenodd", d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z", clipRule: "evenodd" }) }), error] }) })) : (_jsxs("div", { className: "space-y-8", children: [selectedVideo && (_jsx("div", { className: "max-w-4xl mx-auto mb-8", children: _jsx(VideoPlayer, { video: selectedVideo }) })), _jsx("div", { className: "max-w-7xl mx-auto", children: _jsx(VideoGrid, { videos: videos, onVideoSelect: handleVideoSelect, loading: loading }) })] }))] }), _jsx(Toaster, {})] }));
};
